import {html} from '@isceco/widget-library2/external/lit'
import '@isceco/widget-library2/basic-elements/VerticalNavigation/VerticalNavigation.js'
import WebComponent from '../../../WebComponent.js'
import Navigation from '../../Navigation/Navigation.js'
import AuthorizationFilter from '../../Authorization/AuthorizationFilter.js'
import Authorization from '../../Authorization/Authorization.js'

export default class VerbrauchNavigation extends WebComponent {

  constructor() {
    super();
  }

  get translationFile() {
    return './views/Verbrauch/Navigation/i18n.json'
  }

  connectedCallback() {
    super.connectedCallback()
    this.navigationListener = _ => this.reload();
    document.addEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
    this.render()
  }

  disconnectedCallback() {
    document.removeEventListener(Navigation.NAVIGATION_HAPPEND, this.navigationListener)
  }

  getTemplate() {

    const allItems = {
      Verbrauch_Ch: {
        text: this.i18n.translate('navigation.vertical.ch'),
        url: 'Verbrauch_Ch'
      },
      Verbrauch_Chot: {
        text: this.i18n.translate('navigation.vertical.chot'),
        url: 'Verbrauch_Chot'
      },
      Verbrauch_Dch: {
        text: this.i18n.translate('navigation.vertical.dch'),
        url: 'Verbrauch_Dch'
      },
      Verbrauch_Gaznat: {
        text: this.i18n.translate('navigation.vertical.gaznat'),
        url: 'Verbrauch_Gaznat'
      },
      Verbrauch_Ail: {
        text: this.i18n.translate('navigation.vertical.ail'),
        url: 'Verbrauch_Ail'
      },
      Verbrauch_Ego: {
        text: this.i18n.translate('navigation.vertical.ego'),
        url: 'Verbrauch_Ego'
      },
      Verbrauch_Egz: {
        text: this.i18n.translate('navigation.vertical.egz'),
        url: 'Verbrauch_Egz'
      },
      Verbrauch_Gvm: {
        text: this.i18n.translate('navigation.vertical.gvm'),
        url: 'Verbrauch_Gvm'
      }
    }
    const items = getNavigationHash() === Authorization.VIEWS().notAuthorized ? null : AuthorizationFilter.viewsAllowed(Object.keys(allItems)).map(key => allItems[key])
    if (items === null) {
      return html``
    }

    return html`
            <isceco-vertical-navigation
                    .items="${items}">
            </isceco-vertical-navigation>
        `
  }
}
customElements.define('gasmonitoring-frontend-verbrauch-navigation', VerbrauchNavigation)
